import { useEffect, useRef } from "react";

// Hook : ajoute la classe "visible" aux éléments ref quand ils entrent dans le viewport
export function useFadeIn() {
  const refs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("visible"); }),
      { threshold: 0.1 }
    );
    refs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  // Fonction à passer en ref={addRef} sur chaque élément à animer
  const addRef = (el) => {
    if (el && !refs.current.includes(el)) refs.current.push(el);
  };

  return addRef;
}
